export enum AccountType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

export interface Location {
  id: string;
  code: string;
  name: string;
  locationType: string;
}

export interface ChartOfAccount {
  id: string;
  accountCode: string;
  name: string;
  type: AccountType;
}

export interface CreditDebitTracker {
  id: string;
  type: AccountType;
  date: Date;
  chartOfAccountId: string;
  chartOfAccount?: ChartOfAccount;
  locationId?: string;
  location?: Location;
  description: string;
  amount: number;
  referenceNumber?: string;
  referenceDate?: Date;
  preparedBy?: string;
  passedBy?: string;
  isActive: boolean;
  isDeleted: boolean;
  deletedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreditDebitTrackerFormData {
  type: AccountType;
  date: string;
  chartOfAccountId: string;
  locationId: string;
  description: string;
  amount: number;
  referenceNumber: string;
  referenceDate: string;
  preparedBy: string;
  passedBy: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface CreditDebitTrackerFilterParams {
  skip?: number;
  take?: number;
  search?: string;
  type?: AccountType;
  chartOfAccountId?: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
}

export interface AccountBalance {
  totalCredit: number;
  totalDebit: number;
  balance: number;
}
